import { useRef, useState } from "react"
import { CRS } from "./crs-selector"

export const useCRSSelectorState = (allCRSs: CRS[], defaultCRSId?: string) => {
    const [CRSs, setCRSs] = useState<CRS[]>([])
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [hovered, setHovered] = useState(-1)
    const scrollRef = useRef<HTMLDivElement | null>(null)

    const defaultCRS = allCRSs.find((crs) => crs.name === defaultCRSId)
    const [selectedCRS, setSelectedCRS] = useState<CRS | null>(defaultCRS || null)
    const [inputValue, setInputValue] = useState(selectedCRS?.name || "")

    return {
        CRSs,
        setCRSs,
        inputValue,
        setInputValue,
        dropdownOpen,
        setDropdownOpen,
        hovered,
        setHovered,
        scrollRef,
        selectedCRS,
        setSelectedCRS,
    }
}
